import { useTranslation } from "react-i18next";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "it").slice(0, 2);
  const change = (lng) => { i18n.changeLanguage(lng); try { localStorage.setItem("lang", lng); } catch (_) {} };
  const btn = (code, label) => (
    <button
      key={code}
      type="button"
      onClick={() => change(code)}
      data-testid={`lang-${code}`}
      className={`px-2.5 py-1 text-[11px] uppercase tracking-widest rounded-full transition-colors ${
        current === code ? "bg-stone-900 text-white" : "text-stone-500 hover:text-stone-900"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div data-testid="language-switcher" className={`inline-flex items-center gap-1 ${compact ? "" : "border border-stone-200 rounded-full p-0.5 bg-white"}`}>
      {btn("es", "ES")}
      {btn("it", "IT")}
    </div>
  );
}
